export { loginWithTwitter } from './twitter'
export { loginWithFacebook, loginWithFacebookSdk } from './facebook'
export { loginWithGooglePlus, loginWithGooglePlusSdk } from './google'



// WEBPACK FOOTER //
// ./src/users/social/index.js